import Vuex from 'vuex'
import Vue from 'vue'
import {register, getUserInfo, logout, login} from '@/api/login'
import {getToken, setToken, removeToken} from "../request/token"

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        id: '',
        phoneNumber: '',
        name: '',
        avatar: '',
        token: localStorage.token,
    },
    actions:
        {
            register({commit}, user) {
                //Promise 对象代表了未来将要发生的事件，用来传递异步操作的消息。
                //rejected: 意味着操作失败。
                return new Promise((resolve, reject) => {
                    // 异步处理
                    // 处理结束后、调用resolve 或 reject
                    // 当异步代码执行成功时，我们才会调用resolve(...), 当异步代码失败时就会调用reject(...)
                    register(user).then((res) => {
                        if (res.data.success) {
                            commit('SET_TOKEN', res.data.data);
                            localStorage.token = res.data.data;
                            resolve();
                        } else {
                            reject(res.data.msg);
                        }
                    }).catch((error) => {
                        reject(error)
                    })
                })
            },
            getUserInfo({commit}) {
                return new Promise((resolve, reject) => {
                    // 异步处理
                    // 处理结束后、调用resolve 或 reject
                    // 当异步代码执行成功时，我们才会调用resolve(...), 当异步代码失败时就会调用reject(...)
                    getUserInfo().then((res) => {
                        if (res.data.success) {
                            console.log("getUserInfo", res.data.data);
                            commit('SET_ID', res.data.data.id);
                            commit('SET_ACCOUNT', res.data.data.phoneNumber);
                            commit('SET_NAME', res.data.data.name);
                            commit('SET_AVATAR', res.data.data.avatar);
                            resolve(res.data);
                        } else {
                            commit('SET_ID', "");
                            commit('SET_ACCOUNT', "");
                            commit('SET_NAME', "");
                            commit('SET_AVATAR', "");
                            commit("SET_TOKEN", "");
                            removeToken();
                            reject(res.data.msg);
                        }
                    }).catch((error) => {
                        commit('SET_ID', "");
                        commit('SET_ACCOUNT', "");
                        commit('SET_NAME', "");
                        commit('SET_AVATAR', "");
                        commit("SET_TOKEN", "");
                        removeToken();
                        reject(error)
                    })
                })
            },
            logout({commit}) {
                return new Promise((resolve, reject) => {
                    logout().then(res => {
                        if (res.data.success) {
                            commit('SET_TOKEN', '');
                            commit('SET_ACCOUNT', '');
                            commit('SET_NAME', '');
                            commit('SET_AVATAR', '');
                            commit('SET_ID', '');
                            removeToken();
                            resolve();
                        }
                    }).catch(error => {
                        reject(error);
                    })
                })
            },
            login({commit}, user) {
                return new Promise((resolve, reject) => {
                    login(user).then(res => {
                        if (res.data.success) {
                            console.log(res.data.data);
                            commit("SET_TOKEN", res.data.data.token);
                            setToken(res.data.data.token);
                            resolve();
                        }
                    }).catch(error => {
                        reject(error);
                    })
                })
            }
        },
    mutations:
        {
            SET_TOKEN: (state, token) => {
                state.token = token;
            },
            SET_ACCOUNT: (state, account) => {
                state.phoneNumber = account
            },
            SET_NAME: (state, name) => {
                state.name = name
            },
            SET_AVATAR: (state, avatar) => {
                state.avatar = avatar
            },
            SET_ID: (state, id) => {
                state.id = id
            }
        },
})
